/** Keeps a zero-based page index inside [0, pageCount - 1]. */
export const clampPage = (page: number, pageCount: number): number =>
  Math.min(page, Math.max(pageCount - 1, 0));

/** Items of a zero-based page. */
export const getPageItems = <T,>(items: T[], page: number, pageSize: number): T[] =>
  items.slice(page * pageSize, (page + 1) * pageSize);
